import FeedbackEndOfTherapyModule from './FeedbackEndOfTherapyModule'

export default FeedbackEndOfTherapyModule
